<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      title="设置考勤对象"
      edit-title
      id-key="DeviceId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="晚休考勤" prop="NightAttendance" class="is-required">
              <el-radio-group v-model="data.NightAttendance">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>晚休宿舍列表</span>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-plus" @click="addDorm">添加</el-button>
                <el-button type="danger" @click="delDorms">删除</el-button>
              </div>
            </div>
            <el-table ref="tb_dorm" class="tb-c-head" :data="tableData" border>
              <el-table-column type="selection" width="40px" align="center" />
              <el-table-column label="宿舍号" prop="DormitoryNo" align="center" />
              <el-table-column label="操作" align="center" fixed="right" width="80px">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="del(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:12" style="padding-top:12px;margin-bottom: -20px;">
            <el-form-item label="留宿自习考勤" prop="StayAttendance" class="longLabel is-required">
              <el-radio-group v-model="data.StayAttendance">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="row-tb-head">
              <span>留宿班级列表</span>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-plus" @click="addClass">添加</el-button>
              </div>
            </div>
            <el-table class="tb-c-head" :data="tableData2" border>
              <el-table-column label="年级" prop="GradeSn" align="center" width="140px">
                <template slot-scope="{row}">
                  <el-select v-model="row.GradeSn">
                    <el-option :value="1" label="高一"></el-option>
                    <el-option :value="2" label="高二"></el-option>
                    <el-option :value="3" label="高三"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="班级序号" prop="GradeSn" align="center">
                <template slot-scope="{row,$index}">
                  <el-select v-model="row.cs" @change="tbUpdate($index)" placeholder="放空即为所有班级" clearable multiple>
                    <el-option v-for="item in 50" :key="item" :value="item"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" fixed="right" width="60px">
                <template slot-scope="{row,$index}">
                  <el-button type="text" @click="delDevice(row,$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <dorm-dialog ref="dormDialog" in-dialog selectable multiple @select-multiple="setDorms" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import dormDialog from "@/components/lo/dorm/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dormDialog
  },
  data() {
    return {
      data: {
        NightAttendance: 0,
        StayAttendance: 0,
      },
      ids: [],
      tableData: [],
      tableData2: [],
      isMB: this.$store.state.isMB,
      api: require("@/api/cp/device").default,
      rules: {

      },
    };
  },
  methods: {
    onCreateOpened(data) {
      this.ids = data.ids;
    },
    onEditOpened(data) {
     
    },
    addDorm() {
      this.$refs.dormDialog.open().then((that) => {
        that.getData({ DeviceId: this.data.DeviceId });
      });
    },
    setDorms(dorms) {
      if(dorms.length == 0) return;
      var same = [];
      dorms.forEach(e => {
        var obj = this.tableData.find(x => {
          return x.DormitoryId == e.DormitoryId;
        })
        if(obj) {
          same.push(e.DormitoryNumber);
        } else {
          this.tableData.push({
            DeviceDormitoryId: 0,
            DormitoryId: e.DormitoryId,
            DormitoryNo: e.DormitoryAddr + e.DormitoryNumber,
            T: 0,
          });
        }
      })
      if(same.length) {
        this.$message.error("已存在相同的宿舍号：" + same.join("，"));
      }
    },
    addClass() {
      if(this.tableData2.length==3) {
        this.$message.warning("最多添加3条记录");
        return;
      }
      this.tableData2.push({
        T: 0,
        DeviceGradeId: 0,
        DeviceId: this.data.DeviceId,
        GradeSn: 1,
        ClassSns: "",
        cs: [],
      })
    },
    tbUpdate(index) {
      this.tableData2.splice(index,1,this.tableData2[index]);
    },
    delDorms() {
      var rows = this.$refs.tb_dorm.selection;
      if(rows.length==0) {
        this.$message.error("请选择要删除的数据");
        return;
      }
      var ids = rows.map(x => x.DormitoryId);
      ids.forEach(e => {
        var obj = this.tableData.find(x => x.DormitoryId == e);
        var index = this.tableData.findIndex(x => x.DormitoryId == e);
        if(index > -1) {
          this.del(obj,index);
        }
      })
    },
    del(row,index) {
      this.tableData.splice(index,1);
    },
    onBeforeSave() {
      var td = this.tableData;
      var td2 = this.tableData2;
      for (let i = 0; i < td2.length; i++) {
        const e = td2[i];
        for (let j = 0; j < td2.length; j++) {
          const n = td2[j];
          if(n.GradeSn == e.GradeSn && j != i) {
            this.$message.error("留宿列表存在相同的年级");
            return false;
          }
        }
      }
      td2.forEach(e => {
        if(e.cs.length) {
          e.ClassSns = e.cs.join(",");
        } else {
          e.ClassSns = "";
        }
      })
      var DormitoryIds = td.map(x => x.DormitoryId);
      this.loading(true);
      this.api.setAttendance({
        // SaveType: 0,
        DeviceIds: this.ids,
        NightAttendance: this.data.NightAttendance,
        StayAttendance: this.data.StayAttendance,
        DormitoryIds,
        Grades: td2
      }).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else {
          this.$message.error(res.Msg);
        }
      })
      return false;
    },
    onClosed() {
      this.tableData = [];
      this.tableData2 = [];
    }
  },
};
</script>